import { Vector3 } from "@babylonjs/core/Maths/math.vector";
export class SnapPoint {
    /**
     * Find nearest snap point. If pView is null pSnapDistance will be handled as meter otherwise as pixel.
     */
    static Snap(pPos, pPoints, pView, pSnapDistance = 15) {
        if (pPos == null || pPoints == null)
            return (null);
        let tDistance = 0;
        let tNewPos = null;
        for (const tPoint of pPoints) {
            const tD = Math.abs(Vector3.DistanceSquared(pPos, tPoint));
            if (tNewPos == null || tD < tDistance) {
                tNewPos = tPoint;
                tDistance = tD;
            }
        }
        if (tNewPos == null)
            return (null);
        let tSnappedDistance = null;
        if (pView != null) {
            //use pixel distance
            tSnappedDistance = pView.projectedDistance(pPos, tNewPos);
        }
        else {
            //use meter distance
            tSnappedDistance = Math.sqrt(tDistance);
        }
        if (tSnappedDistance != null && tSnappedDistance < pSnapDistance) {
            return (tNewPos);
        }
        return (null);
    }
}
